import React from 'react'
import './team.scss';

const Team = () => {
    return (
        <>
            <section className='Team_main'>
                <div className='inner_team'>
                    <img src='\assets\shade.png' className='shade_img' />
                    <div className='custom-container'>
                        <h2>The Team & Advisory Board</h2>
                        <div className='team_four'>
                            <div className='card_first'>
                                <img src='\assets\issac.svg' />
                                <h3>Isaac Joshua</h3>
                                <h4>Chief Investment Officer, MRKTS – CEO of GEMS | ex-eToro</h4>
                                <p>An experienced blockchain and investment executive with a strong track record in leading fundraising, market strategy, and growth for global fintech and Web3 ventures. As CEO of GEMS and formerly with eToro, he brings extensive expertise in investment strategy, capital markets, and the blockchain industry to MRKTS.
                                </p>
                            </div>
                            <div className='card_first'>
                                <img src='\assets\matteo.svg' />
                                <h3>Matteo Renzi</h3>
                                <h4>Chairman of the Advisory Board – Former Prime Minister of Italy & Parliament Member</h4>
                                <p>Matteo Renzi advises MRKTS on engaging sovereign wealth funds and governments to develop national crypto treasury strategies, including the adoption of the MRKTS basket. He brings decades of political leadership, international relations expertise, and high-level diplomatic access.
                                </p>
                            </div>
                            <div className='card_first'>
                                <img src='\assets\ofer.svg' />
                                <h3>Ofer Malka</h3>
                                <h4>CEO - MRKTS</h4>
                                <p>A senior executive with extensive experience in venture capital, technology, and government leadership. He has held senior roles at JVP, OurCrowd, and Yandex, and served as CEO in a leading Israeli government office. His expertise spans strategic investment, technology growth, and high-level public sector management, offering invaluable insights to MRKTS.
                                </p>
                            </div>
                            <div className='card_first'>
                                <img src='\assets\jullian.svg' />
                                <h3>Julian Lapique</h3>
                                <h4>Advisor – CFO of Chiliz, Fan Tokens & Financial Strategy</h4>
                                <p>Julian Lapique, CFO of Chiliz, brings extensive experience in financial management and blockchain innovation for the global sports and entertainment industry. He advises MRKTS on financial strategy, token economics, and large-scale partner integration.
                                </p>
                            </div>
                             <div className='card_first'>
                                <img src='\assets\amit.svg' />
                                <h3>Amit Levin</h3>
                                <h4>Former Global Investigator, Binance – Compliance & Regulatory Advisor</h4>
                                <p>A seasoned compliance and regulatory expert with deep experience in crypto exchange operations and law enforcement cooperation. As a former Global Investigator in Binance’s Sanctions Department, he oversaw policy development and coordinated with authorities worldwide. At MRKTS, he advises on compliance, sanctions, and regulatory strategy, leveraging his unique blend of crypto industry and prosecutorial expertise.
                                </p>
                            </div>


                        </div>
                    </div>

                </div>
            </section>
        </>
    )
}

export default Team
